export default __webpack_public_path__ + "static/DREAMBIG_YELLOW-7d89e35a1ee268e92985315dbbcd6d4f.png";